import { ISelectOption } from 'common/components/MulltipleSelectCheckmarks/MultipleSelectCheckmarks';

import { generateAnnotationData } from 'features/HorizonScanning/components/ActionPlanLayout/ActionPlanLayoutUtils';
import { AnnotationType } from 'features/RiskProfile/Taxonomy/RemediationPlan/api/type-def';

export enum REGULATION_TREE_CONSTANTS {
	REGULATION_TREE_REG_BOOK_LEVEL = 'Reg Book Level',
}

export enum TAXONOMY_TAB_VALUES {
	CONTROLS_VALUE = 'controls',
	POLICIES_VALUE = 'policies',
	POLICY_VALUE = 'policy',
	RISKS_VALUE = 'risks',
	PROCESSES_VALUE = 'processes',
	CITATIONS_VALUE = 'citations',
	TASKS_VALUE = 'my Tasks',
	FEEDS_VALUE = 'feeds',
	REGULATIONS_VALUE = 'regulations',
	RISK_VALUE = 'risk',
	REGULATION_VALUE = 'regulation',
	CONTROL_VALUE = 'control',
	OBLIGATION_VALUE = 'obligation',
	OBLIGATIONS_VALUE = 'obligations',
	CITATION_VALUE = 'citation',
	PROCESS_VALUE = 'process',
}

export enum ENTITY_TYPE {
	CITATION = 'Citation',
	REGULATION = 'Regulation',
	CONTROL = 'Control',
	POLICY = 'Policy',
	RISK = 'Risk',
	PROCESS = 'Process',
	GROUP = 'Group',
	OBLIGATION = 'Obligation',
	CITATION_GROUP_BU = 'CitationGroupBusinessUnit',
	AI_GENERATED_ENTITY = 'aiCards',
}

export enum RELATED_OBJECT_TYPE {
	GROUP = 'Group',
	HORIZON = 'Horizon',
}

export enum STEPPER_STATUS {
	LEGAL_REVIEW_IN_PROGRESS = 'Legal Review In Progress',
	LEGAL_REVIEW_COMPLETED = 'Legal Review Completed',
	COMPLIANCE_REVIEW_IN_PROGRESS = 'Compliance Review In Progress',
	COMPLIANCE_REVIEW_COMPLETED = 'Compliance Review Completed',
	REMEDIATION_TASK_IMPLEMENTATION_IN_PROGRESS = 'Remediation Task Implementation In Progress',
	TASK_IMPLEMENTATION_COMPLETED = 'Task Implementation Completed',
}

export const PRIORITY_TYPE = ['Low', 'Medium', 'High'];

export enum OVERVIEW_DETAILS_ACCORDIONS {
	PRODUCTS = 'products',
	RELATION_MAPPING = 'relationmapping',
	DESCRIPTION = 'description',
	TAGS = 'tags',
	DETAILS = 'details',
	GRAMMARCHECK = 'grammarcheck',
}

export enum IMPACT_STATUS {
	IMPACT_LOW = 'low',
	IMPACT_MEDIUM = 'medium',
	IMPACT_HIGH = 'high',
}

export enum TASK_PRIORITY_LEVEL_STATUS {
	PRIORITY_LOW = 'low',
	PRIORITY_MEDIUM = 'medium',
	PRIORITY_HIGH = 'high',
}

export enum IMPACT_PARENT_OBJECT_TYPE {
	CITATIONGROUP = 'CitationGroup',
	HORIZON = 'HorizonRegulation',
	CITAION = 'Citation',
}

export enum ENTITY_AI_SCORE {
	HIGH = 'high',
	MEDIUM = 'medium',
	LOW = 'low',
}

export enum ENTITY_STATUS {
	ADD = 'Add',
	ADDED = 'Added',
	REVIEWED = 'Reviewed',
	IMPACTED = 'Impacted',
	NOT_IMPACTED = 'Not Impacted',
	PENDING_REVIEW = 'Pending Review',
	PENDING = 'Pending',
}

export enum DATABASE_KEYS {
	PWC_CURATED_LIBRARY = 'PwC curated library',
	GRC = 'GRC',
}

export const dataBaseOptions = [
	{
		id: 'PWC',
		name: 'PwC curated library',
	},
	{
		id: 'METRIC STREAM',
		name: 'GRC',
	},
];

const {
	PROCESS_VALUE,
	RISK_VALUE,
	CONTROL_VALUE,
	POLICY_VALUE,
	OBLIGATION_VALUE,
} = TAXONOMY_TAB_VALUES;

export const TAXONOMY_CURRENT_TAB_LIST = [
	PROCESS_VALUE,
	RISK_VALUE,
	CONTROL_VALUE,
	OBLIGATION_VALUE,
	POLICY_VALUE,
];

export const tableAnnonationDataTaskData: AnnotationType[] = Array.from(
	new Set([
		generateAnnotationData(
			'label-text',
			'square-icon-obligation',
			'icon-label',
			'obligation',
			'Obligations',
		),
		generateAnnotationData(
			'label-text',
			'square-icon-processes',
			'icon-label',
			'processes',
			'Processes',
		),
		generateAnnotationData(
			'label-text',
			'square-icon-risks',
			'icon-label',
			'Risks',
			'Risks',
		),
		generateAnnotationData(
			'label-text',
			'square-icon-controls',
			'icon-label',
			'controls',
			'Controls',
		),
		generateAnnotationData(
			'label-text',
			'square-icon-policies',
			'icon-label',
			'policies',
			'Policies',
		),
	]),
);

export const iconClassNames: { [key: string]: string } = {
	[ENTITY_TYPE.CONTROL]: 'square-icon-controls',
	[ENTITY_TYPE.POLICY]: 'square-icon-policies',
	[ENTITY_TYPE.RISK]: 'square-icon-risks',
	[ENTITY_TYPE.PROCESS]: 'square-icon-processes',
	[ENTITY_TYPE.OBLIGATION]: 'square-icon-obligation',
	[RELATED_OBJECT_TYPE.GROUP]: 'square-icon-group',
};

export enum ACTION_PLAN_TAB_CONSTANTS {
	TAB_TASKS = 'tasks',
	TAB_MAPPING = 'mapping',
}

export const mappingCategory: { [key: string]: string } = {
	taskImportance: 'Priority',
	taskType: 'Type',
	moduleName: 'Modules',
	status: 'Status',
};

export const IMPACT_ASSESSMENT_ERROR_MSG =
	'Impacts and Tasks need to be addressed in order to save.';

export const CITATIONS_FULLTEXT_TOOLTIP =
	'This section shows the  Full Citation Text for the given Citation.';

export enum ToolbarType {
	TOGGLE_VIEW_HEATMAP,
}

export const taxonomySecTools = [ToolbarType.TOGGLE_VIEW_HEATMAP];

export enum RiskScore {
	RiskScoreRed = 66,
	RiskScoreYellow = 33,
}

export enum RiskScoreColor {
	RiskScoreRed = 'RED',
	RiskScoreYellow = 'YELLOW',
	RiskScoreGreen = 'GREEN',
}
export const RISK_COUNT_MAIN_LABEL = 'What is a Risk count?';
export const RISK_COUNT_LABEL = 'Risk count';
export const RISK_SCORE_LABEL = 'Risk score';
export const RISK_RECENT_ACTIVITY_LABEL = 'Recent activity';
export const RISK_SCORE_CALCULATION_LABEL = 'How is the risk score calculated?';
export const RISK_COUNT_INFO_DESCRIPTION =
	'The Risk count represents the number of risks associated with the selected obligations, processes, risks, or controls in the heatmap view. The risk count ranges from a minimum of 1 to a maximum of 100. A higher risk count indicates a higher level of risk.';

export const RISK_RECENT_ACTIVITY_DESCRIPTION =
	'The Recent activity feature displays an arrow, either up or down, along with the count of the risk score. This arrow indicates the recent change in the total risk score. If the total risk score has recently decreased, the arrow color will be green and facing downwards. On the other hand, if the total risk count has recently increased, the arrow color will be red and facing upwards.';

export const RISK_SCORE_CALCULATION_DESCRIPTION =
	'Risk scoring is accomplished using a proprietary equation that takes relevant data values into consideration. This equation generates a numerical score ranging from 1 to 100, which indicates the level of risk associated with each obligation, process, risk, or control.';

export const RISK_SCORE_GOT_IT_BUTTON = 'Got it';

export const OVERVIEW_TAB_LABEL = 'overview';

export const HIDE_MODIFIED_DATE_COLUMN = ['PWC'];

export const DEFAULT_OBLIGATION_TABLE_COLUMN = 'groupName';

export const DEFAULT_PROCESS_TABLE_COLUMN = 'processName';

export const DEFAULT_RISK_TABLE_COLUMN = 'riskName';

export const DEFAULT_CONTROL_TABLE_COLUMN = 'controlName';

export const DEFAULT_POLICY_TABLE_COLUMN = 'policyName';

export const refreshTimeout = 20 * 1000; // in 20 sec

export const HEAT_MAP_PARAM_KEY = 'heatmapView';

export enum TAXONOMY_TABLE_KEYS {
	OBLIGATION_TABLE_KEY = 'obligationTable',
	CONTROLS_TABLE_KEY = 'controlsTable',
	RISKS_TABLE_KEY = 'risksTable',
	PROCESSES_TABLE_KEY = 'processesTable',
	CITATIONS_TABLE_KEY = 'citationsTable',
	POLICIES_TABLE_KEY = 'policiesTable',
}

export enum TAXONOMY_ENTITY_INDEX {
	CITATION = 'citation-index',
	PROCESS = 'process-index',
	RISK = 'risk-index',
	CONTROL = 'control-index',
	REG_INV_GRP = 'reginv-group-index',
	REG_INV_THEME = 'reginv-theme-index',
	POLICY = 'policy-index',
}

export const OBLIGATION_TABLE_DEFAULT_FILTER = [
	{
		key: 'taskStatus',
		values: ['Complete'],
	},
];

export enum BUSINESS_UNIT_DETAIL {
	NAME = 'businessUnitName',
	ID = 'businessUnitId',
	USER_NAME = 'assignedUserName',
	USER_ID = 'assignedUserId',
}

export const POLICY_TABLE_EXPORT_HEADER_MAPPING = {
	policyName: 'Policy name',
	policyType: 'Type',
	policyPurpose: 'Purpose',
	version: 'Revision number',
	effectiveFrom: 'Effective from',
	effectiveTo: 'Effective to',
	policyOwner: 'Owner',
};

export const POLICY_TABLE_EXPORT_COLUMN_OPTIONS: ISelectOption[] = Object.keys(
	POLICY_TABLE_EXPORT_HEADER_MAPPING,
).map((key) => ({
	label: key,
	value: key,
	checked: true,
}));

export enum LANDING_PAGE_DROPDOWN_TYPE {
	DATABASE = 'database',
	CATEGORY = 'category',
}

const {
	OBLIGATION_TABLE_KEY,
	CONTROLS_TABLE_KEY,
	RISKS_TABLE_KEY,
	PROCESSES_TABLE_KEY,
	POLICIES_TABLE_KEY,
} = TAXONOMY_TABLE_KEYS;

export const PRC_TABLE_KEYS = [
	PROCESSES_TABLE_KEY,
	RISKS_TABLE_KEY,
	CONTROLS_TABLE_KEY,
	OBLIGATION_TABLE_KEY,
	POLICIES_TABLE_KEY,
];

const {
	OBLIGATIONS_VALUE,
	PROCESSES_VALUE,
	CONTROLS_VALUE,
	RISKS_VALUE,
	POLICIES_VALUE,
} = TAXONOMY_TAB_VALUES;

export const PRC_TABLE_TYPE = [
	PROCESSES_VALUE,
	RISKS_VALUE,
	CONTROLS_VALUE,
	OBLIGATIONS_VALUE,
	POLICIES_VALUE,
];

export const PRC_LANDING_ENTITY_COUNT_DEFAULT = {
	riskCount: 0,
	controlCount: 0,
	processCount: 0,
	obligationCount: 0,
	policyCount: 0,
};

export const PRC_LANDING_DROPDOWN_LOADING_MENU_ITEM = [
	{
		label: 'Loading',
		value: 'Loading',
		id: 'Loading',
		active: true,
	},
];
export enum RELATION_MAPPING_TAB_VALUES {
	ALL = 'All',
	PROCESSES = 'Processes',
	RISKS = 'Risks',
	CONTROLS = 'Controls',
	OBLIGATIONS = 'Obligations',
	POLICIES = 'Policies',
	POLICY = 'Policy',
	NONE = 'None',
	AI_GENERATED = 'AI-Generated',
	PRC_MAPPING = 'PRC mapping',
}

const { ALL, RISKS, CONTROLS, OBLIGATIONS, POLICIES, PROCESSES } =
	RELATION_MAPPING_TAB_VALUES;

export const PROCESS_PARENT_RELATION_DATA = [
	{
		label: ALL,
		value: ALL,
	},
	{
		label: RISKS,
		value: RISKS,
		iconClassName: 'circle-icon-risks',
	},
	{
		label: CONTROLS,
		value: CONTROLS,
		iconClassName: 'circle-icon-controls',
	},
	{
		label: OBLIGATIONS,
		value: OBLIGATIONS,
		iconClassName: 'circle-icon-obligations',
	},
	{
		label: POLICIES,
		value: POLICIES,
		iconClassName: 'circle-icon-policies',
	},
];

export const RISK_PARENT_RELATION_DATA = [
	{
		label: ALL,
		value: ALL,
	},
	{
		label: PROCESSES,
		value: PROCESSES,
		iconClassName: 'circle-icon-processes',
	},
	{
		label: CONTROLS,
		value: CONTROLS,
		iconClassName: 'circle-icon-controls',
	},
	{
		label: OBLIGATIONS,
		value: OBLIGATIONS,
		iconClassName: 'circle-icon-obligations',
	},
	{
		label: POLICIES,
		value: POLICIES,
		iconClassName: 'circle-icon-policies',
	},
];

export const CONTROL_PARENT_RELATION_DATA = [
	{
		label: ALL,
		value: ALL,
	},
	{
		label: PROCESSES,
		value: PROCESSES,
		iconClassName: 'circle-icon-processes',
	},
	{
		label: RISKS,
		value: RISKS,
		iconClassName: 'circle-icon-risks',
	},
	{
		label: OBLIGATIONS,
		value: OBLIGATIONS,
		iconClassName: 'circle-icon-obligations',
	},
	{
		label: POLICIES,
		value: POLICIES,
		iconClassName: 'circle-icon-policies',
	},
];

export const OBLIGATION_PARENT_RELATION_DATA = [
	{
		label: ALL,
		value: ALL,
	},
	{
		label: PROCESSES,
		value: PROCESSES,
		iconClassName: 'circle-icon-processes',
	},
	{
		label: RISKS,
		value: RISKS,
		iconClassName: 'circle-icon-risks',
	},
	{
		label: CONTROLS,
		value: CONTROLS,
		iconClassName: 'circle-icon-controls',
	},
	{
		label: POLICIES,
		value: POLICIES,
		iconClassName: 'circle-icon-policies',
	},
];

export const HORIZON_ADD_RELATION_DATA = [
	{
		label: ALL,
		value: ALL,
	},
	{
		label: PROCESSES,
		value: PROCESSES,
		iconClassName: 'circle-icon-processes',
	},
	{
		label: RISKS,
		value: RISKS,
		iconClassName: 'circle-icon-risks',
	},
	{
		label: CONTROLS,
		value: CONTROLS,
		iconClassName: 'circle-icon-controls',
	},
	{
		label: OBLIGATIONS,
		value: OBLIGATIONS,
		iconClassName: 'circle-icon-obligations',
	},
	{
		label: POLICIES,
		value: POLICIES,
		iconClassName: 'circle-icon-policies',
	},
];

export enum ADD_MAPPING_TITLES {
	MODAL_TITLE = 'Select items to add to map to this',
}

export const INDUSTRY_LABEL = 'Industry';
export const ADD_PRODUCT_LABEL = 'Add Product';
export const BUSINESS_UNIT_LABEL = 'Business Unit';

export const FINANCIAL_SERVICES = 'Financial Services (FS)';
export const FINANCIAL_CRIMES = 'Financial Crimes (FC)';
export const HIERARCHY_LABEL = 'Hierarchy';
export const NO_ITEMS_TO_DISPLAY = 'No items to display';
export const FILTER_BUTTON_LABEL = 'Filters';

export enum CONTROL_HEADER_LABEL {
	FREQUENCY = 'Frequency',
	KEY_CONTROL = 'Key control',
	TYPE = 'Type',
	INDUSTRY_TYPE = 'Industry type',
	AUTOMATIC_MANUAL = 'Automatic/Manual',
}

export enum CONTROL_TAB_LABEL {
	CONTROL_OBJECTIVE = 'Control objective',
	CONTROL_STATEMENT = 'Control statement',
	CONTROL_TEST_SCRIPTS = 'Control test scripts',
}

const { CONTROL_OBJECTIVE, CONTROL_STATEMENT, CONTROL_TEST_SCRIPTS } =
	CONTROL_TAB_LABEL;

export const CONTROL_DETAILS_TAB_VALUES = [
	{
		label: CONTROL_OBJECTIVE,
		value: CONTROL_OBJECTIVE,
	},
	{
		label: CONTROL_STATEMENT,
		value: CONTROL_STATEMENT,
	},
	{
		label: CONTROL_TEST_SCRIPTS,
		value: CONTROL_TEST_SCRIPTS,
	},
];

export const OWNER_LABEL = 'Owner';
export const LAST_UPDATED_LABEL = 'Last updated';
export const DETAILS_LABEL = 'Details';
export const RELATIONSHIP_MAPPING_LABEL = 'Relationship mapping';

export enum DATABASE_CATEGORY {
	PWC_CURATED_LIBRARY = 'PWC',
	METRIC_STREAM = 'METRIC STREAM',
}

export enum ICONTROL_TAB_LOADERS {
	CONTROL_OBJECTIVE_LOADER = 'objective',
	CONTROL_STATEMENT_LOADER = 'statement',
	CONTROL_TEST_SCRIPTS_LOADER = 'testscripts',
}

export const RISK_STATEMENT_KEY = 'riskStatement';
export enum GENERATE_MODE {
	AI = 'AI',
	MANUAL = 'MANUAL',
}

export enum PRC_BUTTON_TEXT {
	REGENERATE = 'Regenerate',
	SUBMIT_CHANGES = 'Submit changes',
	DISCARD_CHANGES = 'Discard changes',
	CANCEL = 'Cancel',
	UPDATE = 'Update',
	SUBMIT = 'Submit',
	REMOVE = 'Remove',
}

export enum PRC_META_DATA_KEY {
	INDUSTRY = 'Industry',
	BUSINESS_UNIT = 'Business unit',
}

export enum META_DATA_KEYWORD {
	INDUSTRY_KEYWORD = 'industryType',
	FREQUENCY_KEYWORD = 'frequency',
	TYPE_KEYWORD = 'type',
	KEY_CONTROL_KEYWORD = 'keyControl',
	AUTOMATED_OR_MANUAL_KEYWORD = 'automatedOrManual',
	BUSINESS_UNIT_KEYWORD = 'businessUnit',
	NEW_KEYWORD = 'New',
	STATEMENT_KEYWORD = 'statement',
	OBJECT_KEYWORD = 'objective',
	TEST_SCRIPTS_KEYWORD = 'testScripts',
	RISK_STATEMENT_KEYWORD = 'riskStatement',
	CONTROL_TEST_SCRIPTS_KEYWORD = 'controlTestScripts',
	CONTROL_STATEMENT_KEYWORD = 'controlStatement',
	CONTROL_OBJECTIVE_KEYWORD = 'controlObjective',
}

export enum PRC_TOAST_MSG {
	RELATION_MAPPING_SUCCESS = 'The mapping has been successfully done',
	PRC_CHANGES_SUCCESS = 'Proposed changes submitted successfully',
	PRC_CHANGES_FAILURE = 'Failed to submit proposed changes',
	PRC_REGENERATE_SUCCESS = 'AI cards regenerated successfully',
	PRC_REGENERATE_FAILURE = 'AI cards regeneration failed',
	PRC_REGENERATE_DELETE_SUCCESS = 'Changes discarded successfully',
	PRC_REGENERATE_DELETE_FAILURE = 'Could not discard the changes',
}

export enum PRC_SUBMIT_CHANGES_MODAL_TEXT {
	MODAL_TITLE = 'Submit changes for approval',
	MODAL_SUBTITLE = 'All changes made to this PRC will be submitted for review and will be locked until reviewed by a designated approver.',
}

export const WHY_LABEL = 'Why';

export enum PRC_REMOVE_ENTITY_MODAL_TEXT {
	MODAL_TITLE = 'Remove from Relationship mapping',
	MODAL_SUBTITLE = 'Are you sure you want to remove this PRC from Relationship mapping? You can always add this again using the “Add Mapping” feature.',
}

export enum SUBMIT_CHANGES_MODAL_TYPE {
	SUBMIT = 'Submit',
	REMOVE = 'Remove',
}

export enum ACTION_TYPE {
	ADDED_ACTION = 'Added',
	REMOVED_ACTION = 'Removed',
}

export const getDescName = (type: string) => {
	const { CONTROL, PROCESS, RISK, POLICY } = ENTITY_TYPE;
	switch (type) {
		case CONTROL:
			return 'Control statement';
		case PROCESS:
			return 'Process description';
		case RISK:
			return 'Risk statement';
		case POLICY:
			return 'Policy summary';
		default:
			return 'Description';
	}
};
